// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { FieldDecode, FieldDecodeT, verifyFieldDecode } from "./field-decode";

/**
 * One wire layout of a record, chosen by exact payload length.
 */
export class StructLayout implements flatbuffers.IUnpackableObject<StructLayoutT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): StructLayout {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsStructLayout(bb: flatbuffers.ByteBuffer, obj?: StructLayout): StructLayout {
    return (obj || new StructLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsStructLayout(
    bb: flatbuffers.ByteBuffer,
    obj?: StructLayout,
  ): StructLayout {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new StructLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  size(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  fields(index: number, obj?: FieldDecode): FieldDecode | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new FieldDecode()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  fieldsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startStructLayout(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addSize(builder: flatbuffers.Builder, size: number) {
    builder.addFieldInt32(0, size, 0);
  }

  static addFields(builder: flatbuffers.Builder, fieldsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, fieldsOffset, 0);
  }

  static createFieldsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startFieldsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endStructLayout(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // fields
    return offset;
  }

  static createStructLayout(
    builder: flatbuffers.Builder,
    size: number,
    fieldsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    StructLayout.startStructLayout(builder);
    StructLayout.addSize(builder, size);
    StructLayout.addFields(builder, fieldsOffset);
    return StructLayout.endStructLayout(builder);
  }

  unpack(): StructLayoutT {
    return new StructLayoutT(
      this.size(),
      this.bb!.createObjList<FieldDecode, FieldDecodeT>(
        this.fields.bind(this),
        this.fieldsLength(),
      ),
    );
  }

  unpackTo(_o: StructLayoutT): void {
    _o.size = this.size();
    _o.fields = this.bb!.createObjList<FieldDecode, FieldDecodeT>(
      this.fields.bind(this),
      this.fieldsLength(),
    );
  }

  unpackFields(...fields: string[]): StructLayoutT {
    const t = new StructLayoutT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("size")) {
      t.size = this.size();
    }
    if (fieldSet.has("fields")) {
      t.fields = this.bb!.createObjList<FieldDecode, FieldDecodeT>(
        this.fields.bind(this),
        this.fieldsLength(),
      );
    }
    return t;
  }
}

export class StructLayoutT implements flatbuffers.IGeneratedObject {
  constructor(
    public size: number = 0,
    public fields: FieldDecodeT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.fields === null || this.fields === undefined) {
      throw new Error('Required field "fields" is not set');
    }
    const fields = StructLayout.createFieldsVector(
      builder,
      builder.createObjectOffsetList(this.fields),
    );

    return StructLayout.createStructLayout(builder, this.size, fields);
  }

  clone(): StructLayoutT {
    const obj = new StructLayoutT();
    obj.size = this.size;
    obj.fields = this.fields.map((e) => e.clone());
    return obj;
  }

  equals(other: StructLayoutT): boolean {
    if (this.size !== other.size) return false;
    if (this.fields.length !== other.fields.length) return false;
    for (let i = 0; i < this.fields.length; i++) {
      const a = this.fields[i];
      const b = other.fields[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyStructLayout(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyFieldDecode);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "fields");
  } finally {
    verifier.popDepth();
  }
}
